import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import SearchContent from '~/components/UI/SearchContent'

import getSearchPageStaticPropsFunction from '~/data/search-page-data'
import { SearchPageData } from '~/data/search-page-data/serializer'

function Search({ slices, upsales }: SearchPageData) {
  return (
    <>
      <SearchContent upsales={upsales} />
      <PageViewAnalytics template="search" />
    </>
  )
}

export default Search

export const getStaticProps = getSearchPageStaticPropsFunction()
